import { render, staticRenderFns } from "./siloImg.vue?vue&type=template&id=c35ead3a&"
import script from "./siloImg.vue?vue&type=script&lang=js&"
export * from "./siloImg.vue?vue&type=script&lang=js&"
import style0 from "./siloImg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports